<template>
  <v-expansion-panel>
    <v-expansion-panel-content :key="path(['metadata', 'id'], currentField)" v-if="path(['layout'], currentField)" class="grey lighten-4">
      <div slot="header">
        <v-layout row justify-space-between>
          <v-flex xs5>
            <h3>{{path(['layout', 'property'], currentField)}}</h3>
            <span>row: {{path(['layout', 'row'], field)}}</span>
            <span>column: {{path(['layout', 'column'], field)}}</span>
            <p v-if="validation.$error" class="red--text">Invalid data</p>
          </v-flex>
            <v-btn v-if="!markedToDelete"  color="error" @click="toggleDelete">Mark to Delete</v-btn>
            <v-btn v-else  color="error"
            class="red lighten-3" @click="toggleDelete">Unmark</v-btn>
        </v-layout>
        </div>
      <v-card>
        <v-card-text>
          <v-layout row wrap>
            <v-flex xs5>
              <v-select
                :items="fieldTypes"
                v-model="currentField.layout.type"
                label="Select"
                single-line
                required
                :error="invalidFieldType"
                :error-messages="invalidFieldTypeMessage"
              ></v-select>
              <v-checkbox
                v-if="isTypeSelect"
                label="Set values from outer source"
                v-model="valuesFromOuterSource"
                :disabled="isTypeString"
              />
              <content-field
                label="Label"
                required
                v-model="currentField.layout.label"
              ></content-field>
              <h4 v-if="isTypeNotArray">Validators</h4>
              <v-flex v-if="isTypeNotArray">
                <v-layout row wrap>
                  <v-flex xs6>
                    <v-checkbox
                      label="Only letters"
                      v-model="validators.alpha.isActive"
                      hide-details class="shrink mr-2"
                      :disabled="isTypeNotString">
                    </v-checkbox>
                    <v-checkbox
                      label="Only numbers"
                      v-model="validators.number.isActive"
                      hide-details class="shrink mr-2"
                      :disabled="isTypeNotString">
                    </v-checkbox>
                    <v-checkbox
                      label="Required"
                      v-model="validators.required.isActive"
                      hide-details class="shrink mr-2">
                    </v-checkbox>
                  </v-flex>
                  <v-flex xs6>
                    <v-checkbox
                      label="Email"
                      v-model="validators.email.isActive"
                      hide-details class="shrink mr-2"
                      :disabled="isTypeNotString">
                    </v-checkbox>
                    <v-checkbox
                      label="Url"
                      v-model="validators.url.isActive"
                      hide-details class="shrink mr-2"
                      :disabled="isTypeNotString">
                    </v-checkbox>
                      <v-flex>
                        <v-layout align-center row wrap>
                          <v-flex  xl5 lg12>
                            <v-checkbox
                              label="Max Length"
                              v-model="validators.range.isActive"
                              hide-details class="shrink mr-5"
                              :disabled="isTypeNotString"
                            ></v-checkbox>
                          </v-flex>
                          <v-flex  xl7 lg12>
                            <content-field
                              label="Characters amount"
                              v-model="validators.range.data.max"
                              v-if="validators.range.isActive"
                            ></content-field>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                  </v-flex>
                </v-layout>
              </v-flex>
              <content-field
                label="Width"
                required
                v-model="currentField.layout.width"
                :error="path(['layout', 'width'], validation)"
              />
              <!-- Need for listing textarea and blitz image-->
              <content-field
                v-if="isTypeString || isTypeImage"
                label="Height"
                v-model="currentField.metadata.height"
              />
              <v-checkbox
                v-if="isTypeNotArray"
                label="Multiline"
                v-model="currentField.layout.multiline"
                :disabled="isTypeNotString"
              ></v-checkbox>

            </v-flex>
          <v-flex xs1 />
            <v-flex xs5>
              <v-textarea
                v-if="isTypeNotArray"
                label="Values"
                v-model="currentField.layout.values"
                :disabled="isValuesDisabled || valuesFromOuterSource"
              ></v-textarea>
              <v-select dense
                v-if="valuesFromOuterSource"
                label="Source"
                :items="valuesSources"
                :value="source"
                @input="setValuesFromOuterSource"
                :disabled="isTypeString"
              />
              <content-field
                v-if="isTypeNotArray"
                label="Placeholder"
                v-model="currentField.layout.placeholder"
                :disabled="isTypeNotString"
              ></content-field>
              <content-field
                v-if="isTypeNotArray"
                label="Default Value"
                v-model="currentField.layout.defaultValue"
                :disabled="isTypeString"
              ></content-field>
              {{prop('property', validation)}}
              <content-field
                label="Property"
                required
                v-model="currentField.layout.property"
                :error="path(['layout', 'property'], validation)"
              ></content-field>
              <content-field
                label="Column"
                required
                v-model.number="currentField.layout.column"
                :error="path(['layout', 'column'], validation)"
                @input="changeOrder(currentField.layout.row, currentField.layout.column)"
              ></content-field>
              <content-field
                label="Row"
                required
                v-model.number="currentField.layout.row"
                :error="path(['layout', 'row'], validation)"
                @input="changeOrder(currentField.layout.row, currentField.layout.column)"
              ></content-field>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
import {formValidators} from 'config/formConfig'
import { path, pathOr, pathEq, not, prop, or, assocPath, clone } from 'ramda'

const fieldTypeEq = pathEq(['layout', 'type'])
const isFieldTypeString = fieldTypeEq('string')
const isFieldTypeArray = fieldTypeEq('array')
const isFieldTypeImage = fieldTypeEq('image')
const isFieldTypeSelect = fieldTypeEq('select')

export default {
  name: 'FieldConstructor',
  props: ['field', 'validation'],
  data () {
    return {
      fieldTypes: [
        { text: 'Text', value: 'string' },
        { text: 'Content Editor', value: 'editor' },
        { text: 'Checkbox', value: 'checkbox' },
        { text: 'Radio', value: 'radio' },
        { text: 'Select', value: 'select' },
        { text: 'Image', value: 'image' },
        { text: 'Array', value: 'array' }
      ],
      currentField: clone(this.field),
      validators: {},
      includeFiles: false,
      formValidators,
      markedToDelete: false,
      validate: false,
      valuesFromOuterSource: false,
      valuesSources: [{text: 'Categories', value: 'categories'}],
      source: ''
    }
  },
  computed: {
    type () {
      return this.currentField.layout.type;
    },
    isTypeString () {
      return isFieldTypeString(this.currentField)
    },
    isTypeImage () {
      return isFieldTypeImage(this.currentField)
    },
    isTypeNotString () {
      return not(isFieldTypeString(this.currentField))
    },
    isTypeNotArray () {
      return not(isFieldTypeArray(this.currentField))
    },
    isTypeSelect () {
      return isFieldTypeSelect(this.currentField)
    },
    isValuesDisabled () {
      /* make disable field Values for all type string */
      return this.currentField.layout.type === 'string' || or(isFieldTypeImage(this.currentField), isFieldTypeArray(this.currentField))
      /* previus value */
      //  return or(isFieldTypeImage(this.currentField), isFieldTypeArray(this.currentField))
    },
    invalidFieldType () {
      return path(['layout', 'type', '$invalid'], this.validation) && path(['layout', 'type', '$dirty'], this.validation)
    },
    invalidFieldTypeMessage () {
      return this.invalidFieldType ? ['This field is required'] : []
    }
  },
  watch: {
    valuesFromOuterSource(newVal){
      if(!newVal){
        if(this.source) this.validators = assocPath(['objectId', 'isActive'], false, this.validators)
        this.source = ''
      }
    },
    currentField: {
      handler: function (newVal) {
        this.$emit('fieldChange', newVal)
      },
      deep: true
    },
    validators: {
      handler: function (val) {
        let temp = []
        if (val) {
          Object.keys(val).forEach( key => {
            if (val[key].isActive) {
              temp.push({name: key, data: pathOr({}, ['data'], val[key])})
            }
          })
        }
        this.currentField = assocPath(['layout', 'validators'], temp, this.currentField)
         this.$emit('updateFieldValidator',
         {
           validators: temp,
           id: this.currentField.metadata.id
         })
      },
      deep: true
    },
    type (newVal, oldVal) {
      this.valuesFromOuterSource = false
      if (newVal === 'array') {
        this.currentField.layout.fields = []
        this.validators = Object.assign(this.validators,
          {range: {isActive: true, data: {max: 1} }}
        )
        this.$emit('updateFieldValidator',
        {
          validators: this.validators,
          id: this.currentField.metadata.id
        })
      }
      if (oldVal === 'array') {
        this.validators.range.isActive = false
        this.validators.range.data = {}
      }
      if (newVal === 'select') {
        this.validators.range.isActive = false
        this.validators.range.data = {}
      }
    }
  },
  methods: {
    prop,
    path,
    clearFieldWichWillBeDisabled (type) {
      if (type === 'Image' || 'string') {
        type === 'Image' ? this.currentField.layout.placeholder = null : this.currentField.layout.defaultValue = ''
        this.currentField.layout.values = []
      }
      this.currentField.layout.placeholder = null
      this.clearValidators()
    },
    clearValidators () {
      this.currentField.layout.placeholder = null
      this.validators.alpha.isActive = false
      this.validators.number.isActive = false
      this.validators.email.isActive = false
      this.validators.required.isActive = false
      this.validators.url.isActive = false
      this.validators.range.isActive = false
    },
    toggleDelete (e) {
      e.stopPropagation()
      this.markedToDelete = !this.markedToDelete
      this.$emit('toggleDelete', this.currentField.metadata.id)
    },
    setValuesFromOuterSource (value) {
      this.currentField = assocPath(['layout', 'values'], null, this.currentField)
      this.source = value
      const newValidator = { data: {"CollectionReferenceName": value}, isActive: true }
      this.validators = assocPath(['objectId'], newValidator, this.validators)
    },
    changeOrder (row, column) {
      this.$emit('changeOrder', [parseInt(row), parseInt(column)])
    }
  },
  created () {
    this.currentField = clone(this.field)
    this.formValidators.forEach(validator => {
      this.validators = assocPath([validator], {isActive: false, data: {}}, this.validators)
    })
  },
  mounted () {
    if (this.currentField.layout.validators) {
      this.currentField.layout.validators.forEach(validator => {
        this.validators[validator.name] = {
          isActive: true,
          data: validator.data
        }
        if(validator.name === 'objectId') {
          this.valuesFromOuterSource = true
          this.source = path(['data', 'CollectionReferenceName'], validator)
        }
      })
      this.validators = {...this.validators}
    }
  },
  beforeDestroy(){
    this.$bus.$off('updateFormData')
  }
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// src/components/shared/EvFieldConstructor/index.vue